import { render, staticRenderFns } from "./UpdateDeliveryDateDialog.vue?vue&type=template&id=2a9d4c50&"
import script from "./UpdateDeliveryDateDialog.vue?vue&type=script&lang=ts&"
export * from "./UpdateDeliveryDateDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports